<script>
import icons from './../../helpers/icons';
import authService from "@/api/authService";
import router from "@/router";
import { SidebarMenu } from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import {decrypt, encrypt} from "@/utils/crypto";
import formatDate from "@/utils/formatDate";
import StkModal from "@/components/modals/Stk-Modal.vue";
import subscriptionService from "@/api/subscriptionService";
import employeeService from "@/api/employeeService";
import moment from "moment";

export default {
  name: 'DefaultNavLayout',
  components: {SidebarMenu, StkModal,},

  data() {
    return {
      sidebarWidth: '260px',
      collapsedWidth: '65px',
      organization: {},
      profile: {},
      subscription: {
        package: {}
      },
      accountsUrl: process.env.VUE_APP_ACCOUNTS_URL,
      avatarUrl: process.env.VUE_APP_API_IMAGE_URL + 'user/',
      orgLogoUrl: process.env.VUE_APP_API_IMAGE_URL + 'organization/',
      icons,
      // State of sidebar
      sidebarClosed: false,
      windowWidth: '',
      subscriptionStatus: '',
      employeesNo: 0,
    }
  },
  methods: {
    formatDate,
    async logout() {
      await authService.userLogout()
    },
    myProfile () {
      router.push('/profile')
    },
    mainAccounts () {
      window.open(this.accountsUrl, '_self')
    },
    linkActive(paths) {
      let routeTo = this.$route.path.split('/', 2)[1]
      return paths.includes(routeTo)
    },
    toggleSidebar() {
      this.sidebarClosed = !this.sidebarClosed
    },
    resizeToggle() {
      this.sidebarClosed = window.innerWidth < 1000;
      this.collapsedWidth = window.innerWidth < 600 ? '0px' : '65px';
    },
    getSubscription: async function () {
      if (sessionStorage.getItem('paymentSuccess') === 'true' || sessionStorage.getItem('subscription') === null) {
        this.subscription = await subscriptionService.getSubscription()
      } else {
        this.subscription = JSON.parse(decrypt(sessionStorage.getItem('subscription')))
      }
    },
    getEmployeesNo: async function () {
      if (sessionStorage.getItem('employeesNo') !== null) {
        this.employeesNo = JSON.parse(decrypt(sessionStorage.getItem('employeesNo')))
      } else {
        let employees = await employeeService.getEmployees();
        this.employeesNo = employees.length
      }
    },
    getSubscriptionStatus: function () {
      let today = moment(new Date())
      let to = moment(this.subscription.to)
      let days = to.diff(today, 'days');
      if (this.subscription.package.name === "Free") {
        this.subscriptionStatus = 'active'
      } else if (days < 0) {
        this.subscriptionStatus = 'expired'
      } else if (days === 0) {
        if (today.format("YYYY-MM-DD") === to.format("YYYY-MM-DD")) {
          this.subscriptionStatus = 'expired'
        } else {
          this.subscriptionStatus = 'expiring'
        }
      } else if (days < 4 && days > 0) {
        this.subscriptionStatus = 'expiring'
      } else {
        this.subscriptionStatus = 'active'
      }
      this.amount = this.subscription.price
      sessionStorage.setItem('subscriptionStatus', encrypt(this.subscriptionStatus))
    },
  },

  computed: {
    menu() {
      let superAdmin = this.profile.role !== 'super-admin'
      let primaryUser = this.profile.role !== 'primary'
      let employee = this.profile.role === 'employee'
      let bothAdmins = superAdmin && primaryUser
      let freeMode = this.subscription.package.name === 'Free'
      return [
        {
          hiddenOnCollapse: true,
          attributes: {
            style: 'margin: 15px 0 15px 90px !important;' +
                'cursor: pointer;' +
                'background-image: url(' + this.orgLogo + ');' +
                'background-size: contain;' +
                'background-color: white;' +
                'background-repeat: no-repeat;' +
                'border-radius: 10px;' +
                'width: 40px;' +
                'height: 50px;',
            onclick: () => router.push('/'),
          },
        },
        {
          title: 'Dashboard',
          href: '/dashboard',
          icon: 'bi bi-house',
          active: ['dashboard'],
        },
        {
          title: 'Organization',
          icon: 'bi bi-building',
          hidden: employee,
          child: [
            {
              title: 'Organization Info',
              href: '/organization',
              icon: 'bi bi-building-check',
              class: 'ms-4',
            },
            {
              title: 'Departments',
              href: '/departments',
              icon: 'bi bi-diagram-3',
              class: 'ms-4',
            },
            {
              title: 'Designations',
              href: '/designations',
              icon: 'bi bi-star',
              class: 'ms-4',
            },
            {
              title: 'Work Stations',
              href: '/work-stations',
              icon: 'bi bi-geo-alt',
              class: 'ms-4',
            },
            {
              title: 'Commission Rates',
              href: '/commission-rates',
              icon: 'bi bi-percent',
              class: 'ms-4',
            },
          ],
        },
        {
          title: 'Employees',
          icon: 'bi bi-people',
          isActive: (item) => this.linkActive(item.active),
          active: ['employees', 'employee', 'add-employee', 'edit-employee'],
          hidden: employee,
          child: [
            {
              title: 'All Employees',
              href: '/employees',
              icon: 'bi bi-people',
              class: 'ms-4',
            },
            {
              title: 'Add Employee',
              href: '/add-employee',
              icon: 'bi bi-person-add',
              class: 'ms-4',
            },
            {
              title: 'File Requests',
              href: '/file-requests',
              icon: 'bi bi-file-text',
              class: 'ms-4',
            }
          ]
        },
        {
          title: 'Casuals',
          icon: 'bi bi-people-fill',
          isActive: (item) => this.linkActive(item.active),
          active: ['casuals', 'casual', 'add-casual', 'edit-casual'],
          hidden: employee,
          child: [
            {
              title: 'All Casuals',
              href: '/casuals',
              icon: 'bi bi-people-fill',
              class: 'ms-4',
            },
            {
              title: 'Add Casual',
              href: '/add-casual',
              icon: 'bi bi-person-fill-add',
              class: 'ms-4',
            },
          ]
        },
        {
          title: 'Leave',
          icon: 'bi bi-calendar-check',
          isActive: (item) => this.linkActive(item.active),
          active: ['leave-types', 'leave-requests', 'leave-balances', 'employee-leave', 'leave-analytics'],
          hidden: employee,
          child: [
            {
              title: 'Leave Types',
              href: '/leave-types',
              icon: 'bi bi-list-check',
              class: 'ms-4',
            },
            {
              title: 'Leave Approvers',
              href: '/leave-approvers',
              icon: 'bi bi-person-check',
              class: 'ms-4',
            },
            {
              title: 'Leave Requests',
              href: '/leave-requests',
              icon: 'bi bi-calendar-plus',
              class: 'ms-4',
            },
            {
              title: 'Leave Balances',
              href: '/leave-balances',
              icon: 'bi bi-calendar-week',
              class: 'ms-4',
            },
          ]
        },
        {
          title: 'Performance',
          icon: 'bi bi-bar-chart-steps',
          hidden: employee,
          child: [
            {
              href: '/review-templates',
              title: 'Review Templates',
              icon: 'bi bi-card-checklist',
              isActive: (item) => this.linkActive(item.active),
              active: ['review-templates', 'review-template'],
              class: 'ms-4',
            },
            {
              href: '/review-cycles',
              title: 'Review Cycles',
              icon: 'bi bi-arrow-repeat',
              isActive: (item) => this.linkActive(item.active),
              active: ['review-cycles', 'review-cycle'],
              class: 'ms-4',
            },
            {
              href: '/performance',
              title: 'Performance',
              icon: 'bi bi-graph-up-arrow',
              class: 'ms-4',
            },
          ]
        },
        {
          title: 'Loans',
          href: '/loans',
          active: ['loans', 'loan'],
          icon: 'bi bi-cash-stack',
          hidden: employee,
        },
        {
          title: 'Payrolls',
          icon: 'bi bi-table',
          isActive: (item) => this.linkActive(item.active),
          active: ['payrolls', 'payroll', 'payslip', 'payrollPayouts'],
          hidden: employee,
          child: [
            {
              title: 'Employees',
              href: '/payrolls/employees',
              icon: 'bi bi-table',
              class: 'ms-4',
            },
            {
              title: 'Casuals',
              href: '/payrolls/casuals',
              icon: 'bi bi-table',
              class: 'ms-4',
            },
          ]
        },
        {
          title: 'Account',
          icon: 'bi bi-gear',
          hidden: bothAdmins,
          child: [
            {
              href: '/templates',
              title: 'Payslip Templates',
              icon: 'bi bi-file-earmark-font',
              class: 'ms-4',
            },
            {
              href: '/upgrade',
              title: 'Subscription Plan',
              hidden: freeMode,
              icon: 'bi bi-cloud-arrow-up',
              class: 'ms-4',
            },
            {
              href: '/billing',
              title: 'Billing',
              hidden: freeMode,
              icon: 'bi bi-currency-dollar',
              class: 'ms-4',
            },
            {
              href: '/integration',
              title: 'Bank Integration',
              icon: 'bi bi-link',
              class: 'ms-4',
            },
            {
              href: '/logs',
              title: 'System Logs',
              icon: 'bi bi-clock-history',
              class: 'ms-4',
            },
          ],
        },
        {
          title: 'Users',
          href: '/users',
          icon: 'bi bi-people',
          isActive: (item) => this.linkActive(item.active),
          active: ['users', 'user'],
          hidden: employee,
        },
        {
          title: 'Analytic Reports',
          icon: 'bi bi-clipboard2-data',
          hidden: employee,
          child: [
            {
              href: '/annual-report',
              title: 'Annual Payroll Report',
              icon: 'bi bi-bar-chart',
              class: 'ms-4',
            },
            {
              href: '/monthly-report',
              title: 'Monthly Payroll Report',
              icon: 'bi bi-bar-chart-steps',
              class: 'ms-4',
            },
            // {
            //   href: '/leave-analytics',
            //   title: 'Leave Analytics',
            //   icon: 'bi bi-calendar-check',
            //   class: 'ms-4',
            // },
          ]
        },
        {
          title: 'All Organizations',
          href: '/organizations',
          icon: 'bi bi-buildings',
          active: ['organizations'],
          hidden: superAdmin,
        },
        {
          title: 'System Settings',
          href: '/settings',
          icon: 'bi bi-gear',
          active: ['settings'],
          hidden: superAdmin,
        },
          //////////////
          //
          // Employee only menu
          //
          /////////////
        {
          title: 'My Details',
          href: '/employee/' + this.profile.employee_id,
          icon: 'bi bi-person',
          active: ['employee'],
          hidden: !employee,
        },
        {
          title: 'My Payslips',
          href: '/my-payslips',
          icon: 'bi bi-file-earmark-text',
          active: ['my-payslips'],
          hidden: !employee,
        },
        {
          title: 'Leaves',
          icon: 'bi bi-calendar-check',
          hidden: !employee,
          child: [
            {
              href: '/my-leaves',
              title: 'My Leaves',
              icon: 'bi bi-cash-stack',
              class: 'ms-4',
            },
            {
              href: '/leave-approvals',
              title: 'Leave Approvals',
              icon: 'bi bi-person-check',
              class: 'ms-4',
            },
          ]
        },
        {
          title: 'Loans',
          icon: 'bi bi-cash-coin',
          hidden: !employee,
          child: [
            {
              href: '/my-loans',
              title: 'My Loans',
              icon: 'bi bi-cash-stack',
              class: 'ms-4',
            },
            {
              href: '/guarantor-requests',
              title: 'Guarantor Requests',
              icon: 'bi bi-person-check',
              class: 'ms-4',
            },
          ]
        },
        {
          title: 'Performance',
          icon: 'bi bi-bar-chart-steps',
          isActive: (item) => this.linkActive(item.active),
          active: ['my-reviews', 'performance', 'review'],
          hidden: !employee,
          child: [
            {
              href: '/my-reviews',
              title: 'My Reviews',
              icon: 'bi bi-clipboard-data',
              class: 'ms-4',
            },
            {
              href: '/my-feedback',
              title: 'My Feedback',
              icon: 'bi bi-file-earmark-text',
              class: 'ms-4',
            }
          ]
        },
      ]
    },
    orgLogo() {
      return this.organization.logo !== null ?
          this.orgLogoUrl + this.organization.logo :
          'https://berilot.com/src/img/logos/logo.png'
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.resizeToggle);
    })
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.resizeToggle);
  },

  created: async function () {
    this.organization = JSON.parse(decrypt(sessionStorage.getItem('organization')))
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    await this.getSubscription()
    this.getSubscriptionStatus()
    this.loading = false
    await this.getEmployeesNo()
    this.resizeToggle()
  }
}
</script>

<template>
  <div class="main-container">
    <!-- Sidebar -->
    <sidebar-menu
        :menu="menu"
        hide-toggle
        style="background-color: #0d4072"
        :class="['sidebar', sidebarClosed?'closed':'']"
        :collapsed="sidebarClosed"
        :width="sidebarWidth"
        :widthCollapsed="collapsedWidth"
    />

    <div :class="['app-container', {'sidebar-open':!sidebarClosed}]">
      <Navbar @sidebarToggle="toggleSidebar">
        <template v-slot:default="{toggleSidebar}">
          <div class="d-flex align-items-center w-100">
            <!--Hamburger menu-->
            <div @click="toggleSidebar" class="cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" class="stroke-default" width="30" height="30"
                   viewBox="0 0 24 24" stroke-width="1.5" fill="none" stroke-linecap="round"
                   stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z"/>
                <line x1="4" y1="6" x2="20" y2="6"/>
                <line x1="4" y1="12" x2="20" y2="12"/>
                <line x1="4" y1="18" x2="20" y2="18"/>
              </svg>
            </div>
            <!--Search field-->
            <div class="ms-5 d-none d-sm-block" style="width:500px;">
              <h4>{{ organization.name }}</h4>
            </div>
            <div class="ms-auto d-flex flex-row justify-content-end align-items-center">
              <!--Notification bell-->
              <div class="cursor-pointer position-relative ms-4">
                <Dropdown size="md" menu-classes="dropdown-menu-sm"
                          :popper-config="{placement:'bottom-end'}">
                  <template #button>
                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-default" width="30"
                         height="30" viewBox="0 0 24 24" stroke-width="1.5" stroke="#4CAF50"
                         fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z"/>
                      <path
                          d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"/>
                      <path d="M9 17v1a3 3 0 0 0 6 0v-1"/>
                    </svg>
                    <!--Notification badge-->
                    <Badge pill class="font-size-50 position-absolute" style="top:0;right: 0;">
                    </Badge>
                  </template>
                  <!-- Dropdown content with multiple orders-->
<!--                  <div class="d-flex flex-row p-2 align-content-center justify-content-center" v-for="{name, title} in [-->
<!--                        {-->
<!--                            name: 'notification name',-->
<!--                            title: 'notification title'-->
<!--                        },-->
<!--                    ]">-->
<!--                    <div class="d-flex flex-column justify-content-center me-3">-->
<!--                    </div>-->
<!--                    <div>-->
<!--                      <div class="text-success font-size-100 fw-bold">{{ title }}</div>-->
<!--                      <div class="color-gray-500 font-size-75">{{ name }}</div>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="text-center p-2 font-size-75">
                    <a href="#" class=" color-gray-500">Mark all as read</a>
                  </div>
                </Dropdown>
              </div>
              <!--User avatar with dropdown -->
              <div class="ms-5">
                <Dropdown class="">
                  <template #button>
                    <div
                        class="d-flex flex-row align-items-center justify-content-center cursor-pointer">
                      <div class="me-3">
                        <div class="fw-bold">{{ profile.first_name }}</div>
                        <div class="font-size-75 color-gray-600">{{ profile.role }}</div>
                      </div>
                      <img style="max-width: 30px;" class="rounded-circle"
                           :src="avatarUrl + profile.avatar" alt="avatar">
                    </div>
                  </template>
                  <!-- Dropdown content -->
                  <div class="dropdown-item d-flex align-items-center p-2" @click="mainAccounts">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-house-gear" viewBox="0 0 16 16">
                      <path d="M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708z"/>
                      <path d="M11.886 9.46c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.044c-.613-.181-.613-1.049 0-1.23l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"/>
                    </svg>
                    <div class="ms-3 ">
                      Main Accounts
                    </div>
                  </div>
                  <div class="dropdown-item d-flex align-items-center p-2" @click="myProfile">
                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-default" width="20"
                         height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#4CAF50"
                         fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z"/>
                      <path
                          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    <div class="ms-3 ">
                      My Profile
                    </div>
                  </div>
                  <div class="dropdown-item d-flex align-items-center p-2" @click="logout">
                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-default" width="20"
                         height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#4CAF50"
                         fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z"/>
                      <path
                          d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"/>
                      <path d="M7 12h14l-3 -3m0 6l3 -3"/>
                    </svg>
                    <div class="ms-3">
                      Logout
                    </div>
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>

          <!-- Subscription Alerts -->
          <div v-if="profile.role !== 'employee'" class="row subscription-alert-overlay">
            <div class="col-12">
              <div v-if="subscriptionStatus !== 'active'" role="alert"
                   :class="[subscriptionStatus === 'expiring' ? 'alert-info' : 'alert-danger', 'alert shadow border-0 d-flex align-items-center rounded-4']">
                <vue-feather :type="subscriptionStatus === 'expiring' ? 'alert-circle' : 'alert-triangle'"
                             :stroke="subscriptionStatus === 'expiring' ? '#0dcaf0' : '#dc3545'"
                             size="24" class="me-3"></vue-feather>
                <div class="content d-flex justify-content-between align-items-center flex-grow-1">
                  <span>Your subscription {{ subscriptionStatus }} on {{ formatDate(subscription.to) }}</span>
                  <button v-if="subscription.package.name === 'Trial' || subscription.package.name === 'Free'"
                          class="btn btn-sm btn-primary text-uppercase ms-3 shadow-sm rounded-pill"
                          @click="$router.push('/upgrade')">Upgrade</button>
                  <button v-else class="btn btn-sm btn-primary text-uppercase ms-3 shadow-sm rounded-pill"
                          @click="$refs.stkModal.stkModalOpen()">Renew</button>
                </div>
              </div>
              <div v-if="subscription.employees <= employeesNo" role="alert" class="alert alert-warning shadow border-0 d-flex align-items-center rounded-4">
                <vue-feather type="users" stroke="#ffc107" size="24" class="me-3"></vue-feather>
                <div class="content d-flex justify-content-between align-items-center flex-grow-1">
                  <span>Subscription exceeds limit of {{ subscription.employees }} employees.</span>
                  <button class="btn btn-sm btn-primary text-uppercase ms-3 shadow-sm rounded-pill" @click="$router.push('/upgrade')">Upgrade</button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </Navbar>
      <!-- Content with router view -->
      <div class="content-container container-fluid mt-4 mb-5">
        <div class="row">
          <div class="col">
            <router-view v-slot="{ Component }">
              <transition name="fade" mode="out-in">
                <keep-alive>
                  <component :is="Component" />
                </keep-alive>
              </transition>
            </router-view>
          </div>
        </div>
      </div>
    </div>
  </div>

  <StkModal
      ref="stkModal"
      type="renew"
      :package_id="subscription.package.id"
      :package_name="subscription.package.name"
      :price="subscription.price"
  ></StkModal>

</template>

<style lang="scss">
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-leave-to {
  opacity: 0;
}

.logo-text {
  background: linear-gradient(45deg, var(--bs-primary), var(--bs-secondary));
  background-clip: text;
  color: transparent;
}
.v-sidebar-menu .vsm--link_active {
  background-color: #2c78c1 !important;
}
.v-sidebar-menu .vsm--link_hover {
  background-color: #296eb1 !important;
}
.v-sidebar-menu .vsm--link_level-1.vsm--link_active{
  box-shadow: 4px 0 0 0 #ffffff inset !important;
}
.v-sidebar-menu .vsm--link_level-2.vsm--link_active{
  box-shadow: 4px 0 0 0 #ffffff inset !important;
}
.v-sidebar-menu .vsm--link_level-1 .vsm--icon{
  box-shadow: 1px 0 0 0 #ffffff inset !important;
}
// Added overlay style for subscription alerts
.subscription-alert-overlay {
  position: fixed;
  top: 35px;
  left: 51%;
  transform: translateX(-50%);
  z-index: 1080;
  width: 30%;
}
</style>
